module.exports = __webpack_public_path__ + "687eef849dfce0a4f62c2c29ac4c2f8a.png";